import {automaticApi} from "../../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, put, PutEffect, select } from "redux-saga/effects";
import environment from "@/settings/environment";
import { setCustomer } from "@/redux/ducks/customer";
import { ReducersTypes } from "@/redux/reducers/Models";

declare global {
    interface Window { dataLayer: any[]; }
}

export interface Fetch {
    callback: (success: boolean) => void;
}

export interface GetDataAction {
    type: string;
    payload: Fetch;
}

const getCustomer = (state: ReducersTypes) => state.customerReducer;

export default function* getData({
    payload,
}: GetDataAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const response = yield call(automaticApi.get, `/login-app/${environment.api?.loginVersion ?? "v4"}/userdata`);
        const respondeData = response?.data;

        if (respondeData?.status?.sessionId) {
            window?.dataLayer?.push({
                userId: response?.data?.client?.id
            });
            yield put(
                setCustomer({
                    client: response?.data?.client,
                    account: response?.data?.account,
                    isLoadingVehicles: false,
                })
            );
            const responseProducts = yield call(
                automaticApi.get,
                '/home-app/v1/init/userproduct'
            );
            
            const vehicles = responseProducts?.data?.listVehicle;
            
            // Inicializa selectedVehicles com o primeiro veículo se não houver nenhum selecionado
            // @ts-expect-error
            const customer: ReducersTypes['customerReducer'] = yield select(getCustomer);
            const shouldInitializeSelectedVehicles = vehicles?.length > 0 && 
              (!customer?.selectedVehicles || customer.selectedVehicles.length === 0);
            
            yield put(
                setCustomer({
                    products: responseProducts?.data?.products,
                    vehicles: vehicles,
                    ...(shouldInitializeSelectedVehicles && { selectedVehicles: [vehicles[0].plate] })
                })
            );
            yield call(payload.callback, true);
        } else {
            yield put(
                setCustomer({
                    isLoadingVehicles: false,
                })
            );
            yield call(payload.callback, false);
        }

    } catch (error) {
        yield put(
            setCustomer({
                isLoadingVehicles: false,
            })
        );
        yield call(payload.callback, false);
    }
}